var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "100%" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("remove_red_eye")]),
                  _vm._v("Ver detalle solicitud\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "py-0",
                          staticStyle: { "min-width": "100%" },
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", [
                              _c("strong", [_vm._v("SERVIDOR PÚBLICO: ")]),
                              _vm._v(
                                _vm._s(this.form.servidor_publico) +
                                  "\n              "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-data-table", {
                                    staticClass:
                                      "elevation-1 tabla-comprimida-light",
                                    attrs: {
                                      headers: _vm.headers,
                                      items: _vm.lista_funcionarios_vacaciones,
                                      "no-data-text": "Sin datos"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "headerCell",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "span",
                                                            _vm._g({}, on),
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    props.header
                                                                      .text
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        props.header.text
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "items",
                                        fn: function(items) {
                                          return [
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      items.item
                                                        .servidor_publico
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm
                                                        .$moment(
                                                          items.item
                                                            .fecha_incorporacion,
                                                          "YYYY-MM-DD"
                                                        )
                                                        .format("DD/MM/YYYY")
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      items.item.dias_saldo_a
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      items.item.dias_saldo_b
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      items.item.dias_saldo_c
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      items.item
                                                        .total_dias_saldo
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      items.item.dias_programar
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      items.item
                                                        .dias_no_programados
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[0],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[1],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[2],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[3],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[4],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[5],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[6],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[7],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[8],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[9],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[10],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("tr", [
                                                  _c("th", [_vm._v("INICIO")]),
                                                  _vm._v(" "),
                                                  _c("th", [_vm._v("FIN")])
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  items.item.vector_meses[11],
                                                  function(programacion) {
                                                    return _c(
                                                      "tr",
                                                      { key: programacion.id },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_desde
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                programacion.fecha_hasta
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(items.item.estado) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", loading: _vm.loading },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("close")]),
                      _vm._v("\n          Cerrrar\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c25d9b84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c25d9b84","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/VerDetalleSolicitudesProgramacion.vue
// module id = null
// module chunks = 